// extracted by mini-css-extract-plugin
module.exports = {"kensaForm_Action_Container":"OrderFormAction_kensaForm_Action_Container__3y102","kensaForm_Action_Button":"OrderFormAction_kensaForm_Action_Button__1Sduv"};